import {createContext,useContext} from 'react'
import { makeAutoObservable, runInAction } from "mobx";
import {getMethodData,putMethod, patchMethodData, postFormData} from "../../ApiMethods/api"
import { toast } from "react-toastify";

export class CtaStore {
    Token = null;
    indexPage=1;
    activePage=1;
    checkbox = 0;
    Count=1;
    perPage="";
    filterVisibility=true;
    ctas = [];
    loadCta = false;
    errloadCta = "";
    nolist = false;
    filtertrue=false;
    singleCta;
    nofilterwithpagination= false;
    addloadcta= false;
    addedloadcta= false;
    erraddcta="";
    name= "";
    keywords="";
    status="";
    image="";
    imageurl="";
    Screen="";
    price= "";
    ctaid= "";
    link="";
    saved = false;
    content="";

    loadProducttype=false;
    errProducttypelist = "";
    noProducttypelist=true;
    Producttypelist=[]
    previousValues = {
      name: "",
      status:"",
      type_id:""
    };

    constructor(isloading = false) {
        makeAutoObservable(this);
       
        this.Token = localStorage.getItem("Admintoken");
        if(isloading.isloadingtype){

        }
        if(isloading.isloading){
            this.getCtas(isloading.pagginationcount);
            return
        }
        if(isloading.editloading){
            this.getCtaone(isloading.id);

            return
        }
    }

    setname = (text) =>  {
        this.name = text;
    }
    setToken = (text) =>  {
      this.Token = text;
    }
    setScreen = (text) =>  {
      this.Screen = text;
  }
    setkeywords = (text) =>  {
        this.keywords = text;
    }
    setstatus = (text) =>  {
        this.status = text;
    }
    setimage = (text) =>  {
      if(text){
        this.image = text;
        this.imageurl = URL.createObjectURL(text);
      }else{
        this.image = "";
        this.imageurl ="";
      }
    }

    setlink = (text) =>  {
      this.link = text;
  }

    getstatusid = (text) => {
        this.ctaid = text;
    }
    setActivePage = (text) =>{
      this.activePage = text;
    }
    setIndexPage=(e)=>{
      this.indexPage=e;
    }
    setCount=(e)=>{
      this.Count=e;
    }
    setPerPage=(e)=>{
      this.perPage=e;
    }
    setFilterVisibility=(e)=>{
      this.filterVisibility=e;
    }
    setcheckbox=(text)=>{
      this.checkbox =text
  
    }
    NofilterwithPagination = (e) => {
      runInAction(() => {
          this.nofilterwithpagination = e
      })
    }
    setcontent=(e)=>{
      this.content=e;
    }

           // get product type list
           getProducttypeList = (Token) => {
            runInAction(() => {
              this.loadProducttype = true;
              this.errProducttypelist = "";
            });
            getMethodData(`/admin/product-types`, this.Token||Token)
              .then((resp) => {
                if (resp?.data?.status === false) {
                  runInAction(() => {
                    this.loadProducttype = false;
                    this.errProducttypelist = "";
                  });
                  return;
                }
                if (resp?.data?.status === true) {
                  runInAction(() => {
                    this.loadProducttype = false;
                    this.errProducttypelist = resp?.data?.message;
                    if (resp?.data?.data?.length === 0) {
                      this.noProducttypelist = true;
                    } else {
                      this.noProducttypelist = false;
                    }
                    this.Producttypelist = resp?.data?.data;
                  });
                  return;
                }
                runInAction(() => {
                  this.loadProducttype = false;
                  this.errProducttypelist = resp?.data?.message;
                });
              })
              .catch((error) => {
                runInAction(() => {
                  this.loadProducttype = false;
                  if (!error.response) {
                    toast.error(error?.message);
                  }
                  toast.error(error?.response?.data?.message);
                });
                return;
              });
          };

        // get cta List
        getCtas = (pageNumber,Token) => {
            runInAction(() => {
                this.loadCta = true;
                this.errloadCta = "";
                this.saved = false;
                this.ctas=[];
                this.indexPage = pageNumber;
                });
            // getMethodData("/admin/ctas",this.Token)
            getMethodData(`/admin/ctas?page=${pageNumber}`,this.Token||Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                    runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message
                    });
                    return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message;
                    // console.log(resp?.data?.data.length);
                    if(resp?.data?.data?.data?.length === 0) {
                        this.nolist = true;
                    }else{
                        this.nolist = false;
                    }
                    // console.log(resp?.data?.data?.data)
                    this.ctas = resp?.data?.data?.data;
                    this.Count = resp?.data?.data?.total;
                    this.perPage = resp?.data?.data?.per_page;
                    this.activePage = resp?.data?.data?.current_page;
                    this.saved = false;
                    this.filterVisibility = true;
                    // this.status = true;
                    });
                    return;
                }
                runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message;
                });
                })
                .catch((error) => {
                runInAction(() => {
                    this.loadCta = false;
                    if(!error.response){
                        this.errloadCta = error?.message;
                        toast.error(error?.message);
                    }
                    this.errloadCta = error?.response?.data?.message;
                    toast.error(error?.response?.data?.message);
                })
                return;
            });
        };
        loadTableData = async (pageNumber) => {
          runInAction(() => {
            this.loadCta = true;
            this.errloadCta = "";
            this.saved = false;
            this.setIndexPage(1);
            });
          try {
            const response = await getMethodData(`/admin/ctas?page=${pageNumber === 1 ? 1 : pageNumber}`,this.Token)
            if (response?.data?.status === false) {
              runInAction(() => {
              this.loadCta = false;
              this.errloadCta = response?.data?.message
              });
              return;
          }
          if (response?.data?.status === true) {
            runInAction(() => {
              this.loadCta = false;
              this.errloadCta = response?.data?.message;
              // console.log(resp?.data?.data.length);
              if(response?.data?.data?.data?.length === 0) {
                  this.nolist = true;
              }else{
                  this.nolist = false;
              }
                this.setCount(response.data.data.total);
                this.setPerPage(response.data.data.per_page);
                this.setActivePage(response.data.data.current_page)
                this.ctas = response?.data?.data?.data;
                this.filterVisibility = true;
    });
          }
    
        
      
          } catch (error) {
            runInAction(() => {
              this.loadCta = false;
              console.error("Error loading table data:", error);
          });
          }
        };
            //get cta edit data (show)

    getCtaone =(id) => {
        getMethodData( `/admin/ctas/edit/${id}`, this.Token)
        .then((resp) => {
            runInAction(() => {
                this.loadCta = true;
                this.errloadCta = "";
              });
          if (resp?.data?.status === false) {
            runInAction(() => {
              this.loadCta = false;
              this.errloadCta = resp.data.message;
              // toast.error(resp.data.message);
            });
            return;
          }
          if (resp?.data?.status === true) {
            runInAction(() => {
                this.loadCta = false;
                this.singleCta =  resp?.data?.data
                this.name = resp?.data?.data?.name
                this.content = resp?.data?.data?.content
                this.link = resp?.data?.data?.link
                this.checkbox= resp?.data?.data?.is_internal_link
                this.status = resp?.data?.data?.status
                this.image = resp?.data?.data?.image
                this.imageurl = resp?.data?.data?.image
            })
            return;
          }
          runInAction(() => {
            this.loadCta = false;
            this.errloadCta = resp.data.message;
            toast.error(resp.data.message);
          });
        })
        .catch((error) => {
          runInAction(() => {
              if(!error.response){
                this.loadCta = false;
                this.errloadCta = error?.message;
                toast.error(error?.message);
              }
                toast.error(error?.response?.data?.message);
                this.loadCta = false;
                this.errloadCta = error?.response?.data?.message;
          })
          return;
      })
    }


         // cta add

 addcta = () => {
    runInAction(() => {
      this.addedloadcta = true;
      this.erraddcta = "";
    });
    const formData = new FormData();
    formData.append("name", this.name);
    formData.append("link", this.link);
    formData.append("is_internal_link", this.checkbox);
    formData.append("status", this.status);
    formData.append("content", this.content);
    formData.append("image", this.image);
    postFormData(`/admin/ctas/store`,formData,this.Token)
      .then((resp) => {
        if (resp?.data?.status === false) {
          runInAction(() => {
            this.addedloadcta = false;
            this.erraddcta = resp?.data?.message;
            toast.error(resp.data?.data?.errors?.name[0]);
          });
          return;
        }
        if (resp?.data?.status === true) {
          runInAction(() => {
              this.addedloadcta = false;
              this.erraddcta = resp?.data?.message;
              toast.success(resp.data.message);
              //  this.getCtas();
              this.saved = true;
            })
            return
        }
        runInAction(() => {
          this.addedloadcta = false;
          this.erraddcta = resp?.data?.message;
          toast.error(resp.data.message);
        });
      })
      .catch((error) => {
        
        runInAction(() => {
            if(!error.response){
                
              this.addedloadcta = false;
              this.erraddcta = error?.message;
              toast.error(error?.message);
            }
                
              toast.error(error?.response?.data?.message);
              this.addedloadcta = false;
              this.erraddcta = error?.response?.data?.message;
        })
        return;
    })
  };

  editcta = (id) => {
    runInAction(() => {
      this.addloadcta = true;
      this.erraddcta = "";
    });
    
    const formData = new FormData();
    formData.append("name", this.name);
    formData.append("content", this.content);
    formData.append("is_internal_link", this.checkbox);
    formData.append("link", this.link);
    formData.append("status", this.status);

    // Check if the image is available and handle it properly
    if (this.image) {
        // Assuming `this.image[0]` is a File object
        if (this.image) {
            formData.append("image", this.image);
        } else {
            // Handle case where image is not a File (for example, if it's a base64 string or other format)
            console.error("Image is not a valid file object");
        }
    } else {
        formData.delete("image");
    }

    postFormData(`/admin/ctas/update/${id}`, formData, this.Token)
      .then((resp) => {
        if (resp?.data?.status === false) {
          runInAction(() => {
            this.addloadcta = false;
            this.erraddcta = resp?.data?.message;
            toast.error(resp.data?.data?.errors?.name[0]);
          });
          return;
        }
        if (resp?.data?.status === true) {
          runInAction(() => {
              this.addloadcta = false;
              this.erraddcta = resp?.data?.message;
              toast.success(resp.data.message);
              //  this.getCtas();
              this.saved = true;
            });
            return;
        }
        runInAction(() => {
          this.addloadcta = false;
          this.erraddcta = resp?.data?.message;
          toast.error(resp.data.message);
        });
      })
      .catch((error) => {
        runInAction(() => {
            if (!error.response) {
              this.addloadcta = false;
              this.erraddcta = error?.message;
              toast.error(error?.message);
            } else {
              toast.error(error?.response?.data?.message);
              this.addloadcta = false;
              this.erraddcta = error?.response?.data?.message;
            }
        });
        return;
    });
};


    //Active and inactive
statusChange = (currentPage) => {
    runInAction(() => {
      this.loadCta = true;
      this.errloadCta = "";
    });
    getMethodData(`/admin/ctas/change-status/${this.ctaid}`,this.Token)
      .then((resp) => {
        if (resp?.data?.status === false) {
          runInAction(() => {
            this.loadCta = false;
            this.errloadCta = resp?.data?.message;
            // toast.error(resp?.data?.message);
          });
          return;
        }
        if (resp?.data?.status === true) {
          runInAction(() => {
            this.loadCta = false;
            this.errloadCta = resp?.data?.message;
            this.getCtas(currentPage ?? 1);
            toast.success(resp?.data?.message);
          })
          this.setIndexPage(currentPage);
          return;
        }
        runInAction(() => {
          this.loadCta = false;
          this.errloadCta = resp?.data?.message;
        })
      })
      .catch((error) => {
        runInAction(() => {
            if(!error.response){
              this.loadCta = false;
              this.errloadCta = error?.message;
              toast.error(error?.message);
            }
              toast.error(error?.response?.data?.message);
              this.loadCta = false;
              this.errloadCta = error?.response?.data?.message;
        })
        return;
    })
  };
setfiltertrue=(e)=>{
  this.filtertrue = e;
}

     //filter user api 

     getFilterCta = (page,Token) => {
        runInAction(() => {
            this.activePage = page;
            this.loadCta = true;
            this.indexPage = page;
            this.errloadCta = "";
            this.saved = false;
            this.ctas=[];
            if(!this.nofilterwithpagination){
              this.previousValues = {
                status: this.status,
                name: this.name,
              };
            }
          });
      
          if(this.nofilterwithpagination){
            getMethodData(`/admin/ctas?page=${page}&status=${ this.previousValues?.status}&name=${ this.previousValues?.name}`,this.Token||Token)
            .then((resp) => {
                if (resp?.data?.status === false) {
                  runInAction(() => {
                    this.loadCta = false;
                    this.errloadCta = resp?.data?.message
                  });
                  return;
                }
                if (resp?.data?.status === true) {
                    runInAction(() => {
                        this.loadCta = false;
                        this.filtertrue = true;
                        this.errloadCta = resp?.data?.message;
                        // console.log(resp?.data?.data.length);
                        if(resp?.data?.data?.data?.length === 0) {
                            this.nolist = true;
                        }else{
                            this.nolist = false;
                        }
                        // console.log(resp?.data?.data?.data)
                        this.ctas = resp?.data?.data?.data;
                        this.Count = resp.data.data.total;
                        this.perPage = resp.data.data.per_page;
                        this.activePage = resp?.data?.data?.current_page;
                        this.saved = false;
                        this.filterVisibility = true;
                        // this.status = true;
                        });
                  return;
                }
                runInAction(() => {
                  this.loadCta = false;
                  this.errloadCta = resp?.data?.message;
                });
              })
              return;
            
          }
        getMethodData(`/admin/ctas?page=${page}&status=${this.status}&name=${this.name}`,this.Token||Token)
        .then((resp) => {
            if (resp?.data?.status === false) {
              runInAction(() => {
                this.loadCta = false;
                this.errloadCta = resp?.data?.message
              });
              return;
            }
            if (resp?.data?.status === true) {
                runInAction(() => {
                    this.loadCta = false;
                    this.filtertrue = true;
                    this.errloadCta = resp?.data?.message;
                    // console.log(resp?.data?.data.length);
                    if(resp?.data?.data?.data?.length === 0) {
                        this.nolist = true;
                    }else{
                        this.nolist = false;
                    }
                    // console.log(resp?.data?.data?.data)
                    this.ctas = resp?.data?.data?.data;
                    this.Count = resp.data.data.total;
                    this.perPage = resp.data.data.per_page;
                    this.activePage = resp?.data?.data?.current_page;
                    this.saved = false;
                    this.filterVisibility = true;
                    // this.status = true;
                    });
              return;
            }
            runInAction(() => {
              this.loadCta = false;
              this.errloadCta = resp?.data?.message;
            });
          })
          .catch((error) => {
            runInAction(() => {
                this.loadCta = false;
                if(!error.response){
                    this.errloadCta = error?.message;
                    toast.error(error?.message);
                }
                this.errloadCta = error?.response?.data?.message;
                toast.error(error?.response?.data?.message);
            })
            return;
        });
    };


};


export const CtaStoreContext = createContext(new CtaStore());
export const useCtaStore = () => useContext(CtaStoreContext);